import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { HardwareStatus } from '../../services/domainServices/HardwareService';

interface Data {
  type: string;
  category: string;
  brand: string;
  model: string;
  jitTag: string;
  serialNumber: string;
  valueInUse: string;
  atHome: boolean;
  status: HardwareStatus;
  action: any;
}

interface Column {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
  unassignModeOnly: boolean;
}

const columns: Column[] = [
  {
    id: 'type',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'type',
  },
  {
    id: 'category',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'category',
  },
  {
    id: 'brand',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'brand',
  },
  {
    id: 'model',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'model',
  },
  {
    id: 'jitTag',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'JIT tag',
  },
  {
    id: 'serialNumber',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'serial number',
  },
  {
    id: 'valueInUse',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'current value',
  },
  {
    id: 'atHome',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'at home',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: true,
    label: 'status',
  },
  {
    id: 'action',
    numeric: false,
    disablePadding: true,
    unassignModeOnly: false,
    label: 'action',
  },
];

interface AssignHardwareTableHeaderProps {
  numSelected: number;
  onSelectAllClick: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
  rowCount: number;
  unassignMode?: boolean;
}

export const AssignHardwareTableHeader = ({
  onSelectAllClick,
  numSelected,
  rowCount,
  unassignMode = false,
}: AssignHardwareTableHeaderProps) => (
  <TableHead>
    <TableRow>
      <TableCell padding="checkbox">
        {unassignMode ? (
          <Checkbox
            color="primary"
            checked={numSelected > 0 && rowCount > 0}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        ) : null}
      </TableCell>
      {columns
        .filter((column) => !column.unassignModeOnly || unassignMode)
        .map((column) => (
          <TableCell key={column.id} align="left">
            {column.label}
          </TableCell>
        ))}
    </TableRow>
  </TableHead>
);
